import type { InvoiceChannel } from '../customer/document-delivery';

/**
 * Self-billing send channels, modelled on the customer invoice channels. Self-bills are
 * always visible in the carrier portal; email and Peppol are extra channels.
 */
export function selfBillChannelsFromSupplier(supplier: {
  emailEnabled: boolean;
  peppolEnabled: boolean;
}): InvoiceChannel[] {
  const channels: InvoiceChannel[] = [];
  if (supplier.emailEnabled) {
    channels.push('email');
  }
  if (supplier.peppolEnabled) {
    channels.push('peppol');
  }
  return channels;
}

/** Belgian carriers get email + Peppol; foreign carriers usually aren't on Peppol. */
export function defaultSelfBillChannelsForCountry(country: string | undefined): InvoiceChannel[] {
  return country === 'BE' ? ['email', 'peppol'] : ['email'];
}
